import { firebase, db } from '../modules/firebase-module';

export const streamPrototypes = (accountId, observer) => {
  return db.collection('prototypeList')
    .doc(accountId)
    .collection('items')
    .orderBy('created')
    .onSnapshot(observer);
};

export default {
  streamPrototypes,
}
